module.exports = __webpack_public_path__ + "static/media/ROGER&GALLET.2b3a86c7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo/ROGER&GALLET.jpg
// module id = 6317
// module chunks = 0